import axios from "axios";

const makePostRequest = async (url, data, headers = {}) => {
  const config = {
    method: "post",
    url,
    data,
    headers,
  };
  const response = await axios(config);
  return response;
};

const makeGetRequest = async (url, headers = {}) => {
  let config = {
    method: "get",
    headers,
    url,
  };
  const response = await axios(config);
  return response;
};

const makePutRequest = async (url, data) => {
  const config = {
    method: "put",
    url,
    data,
  };
  const response = await axios(config);
  return response;
};

const makeDeleteRequest = async (url, headers = {}) => {
  let config = {
    method: "delete",
    url,
    headers,
  };
  const response = await axios(config);
  return response;
};

export { makeGetRequest, makePostRequest, makePutRequest, makeDeleteRequest };
